module.exports = __webpack_public_path__ + "img/titlebar.36a7c8ef.png";